export { default as returnDetailsDropdownsReducer } from './detailsDropdowns';
export { default as equityReducer } from './equity';
export { default as equityProductsSearchReducer } from './productsSearch';
export { default as equityProductsGuideReducer } from './productsGuide';
export { default as validateProductsReducer } from './validateProducts';
export { default as productTemplatesFilterReducer } from './productsTemplatesFilter';
export { default as consignmentReturnProgressBarReducer } from './progressBar';
export { default as productDetailsReducer } from './productDetails';
export { default as shippingMethodsReducer } from './shippingMethods';
export { default as shipToAddressReducer } from './shipToAddress';
export { default as shippingBatchAllocation } from './shippingBatchAllocations';
export { default as createSurgeryReducer } from './createSurgery';
export { default as surgeryDetailsReducer } from './surgeryDetails';
export { default as updateSurgeryReducer } from './updateSurgery';
export { default as productTemplatesReducer } from './productTemplates';
export { default as consignmentCommonReducer } from './common';
export { default as equityDetailsReducer } from './equityDetails';
export { default as createEquityReducer } from './createEquity';
export { default as validateAccountReducer } from './validateAccount';
export { default as consignmentReturnRootReducer } from './consignmentBilling';
export { default as consignmentReturnDetailsReducer } from './consignmentDetails';
export { default as consignmentReturnReducer } from './consignment';
export { default as gridDataReducer } from './gridData';
export { default as InventoryReturnReducer } from './inventoryDetails';
export {default as consignmentReturnOrderReducer } from './consignmentReturnOrderReducer';
// export { default as equityDetailsDropdownsReducer } from './detailsDropdowns';
// export { default as equitySurgeryReducer } from './surgery';
// export { default as equityProductsSearchReducer } from './productsSearch';
// export { default as equityProductsGuideReducer } from './productsGuide';
// export { default as equityValidateProductsReducer } from './validateProducts';
// export { default as equityProductTemplatesFilterReducer } from './productsTemplatesFilter';
// export { default as equityProgressBarReducer } from './progressBar';
// export { default as equityProductDetailsReducer } from './productDetails';
// export { default as equityShippingMethodsReducer } from './shippingMethods';
// export { default as equityShipToAddressReducer } from './shipToAddress';
// export { default as equityShippingBatchAllocation } from './shippingBatchAllocations';
// export { default as equityCreateSurgeryReducer } from './createSurgery';
// export { default as equitySurgeryDetailsReducer } from './surgeryDetails';
// export { default as equityUpdateSurgeryReducer } from './updateSurgery';
// export { default as equityProductTemplatesReducer } from './productTemplates';
// export { default as equityCommonReducer } from './common';
